module.exports = __webpack_public_path__ + "img/horbach_16_9_w1000.642ed31f.webp";